export function analysisUrl(url) {
  let hrr = []
  let obj = {}
  //截取内部参数
  let params = url.substr(url.indexOf('?') + 1)
  //逗号隔开
  let str = params.replace(/\&/g, ',')
  console.log(str)
  let crr = []
  str.split(',').map((i, index) => {
    crr.push(i.replace(/\=/g, ',').split())
  })
  crr.map(item => {
    item.forEach(i => {
      hrr.push(i.split(','))
    })
  })
  hrr.map(item => {
    obj[item[0]] = item[1]
  })
  console.log(obj)
  return obj
}
export function locationReplace(url) {
  if (history.replaceState) {
    console.log(url, 'url1')
    history.replaceState(null, document.title, url);
    history.go(0);
  } else {
    console.log(url, 'url2')
    location.replace(url);
  }
}
